"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZFeedbackInsert = exports.FeedbackRefKeyEnum = exports.FeedbackActionEnum = void 0;
const types_1 = require("@daymade/common-lib/types");
const zodSchemas_generated_1 = require("../generated/zodSchemas.generated");
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const dbJsonModels_1 = require("@daymade/common-lib/dbJsonModels");
exports.FeedbackActionEnum = dbEnums_1.FeedbackAction;
exports.FeedbackRefKeyEnum = dbEnums_1.FeedbackRefKey;
exports.ZFeedbackInsert = zodSchemas_generated_1.zodInsertFeedback.extend((0, types_1.ensureSubsetOfKeys)(zodSchemas_generated_1.zodInsertFeedback.shape, {
    feedback: dbJsonModels_1.ZFeedbackContent,
}));
//# sourceMappingURL=models.js.map